import { configureStore } from '@reduxjs/toolkit'
import sqlFormatterReducer from "@/state/features/sqlFormatter";
import conversionReducer from "@/state/features/dataConverter";

export const makeStore = () => {
    return configureStore({
        reducer: {
            sqlFormatter: sqlFormatterReducer,
            conversions: conversionReducer,
        },
    })
}

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
